import { render } from "./GroupTable.vue?vue&type=template&id=7641c154&scoped=true"
import script from "./GroupTable.vue?vue&type=script&lang=js"
export * from "./GroupTable.vue?vue&type=script&lang=js"

import "./GroupTable.vue?vue&type=style&index=0&id=7641c154&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7641c154"]])

export default __exports__